<div class="container">
  <div class="card">
    <div class="formBox">
      <h2 class="welcomeTitle">Trust This Device </h2>
      <p class="welcomePara">Name this device to easily identify it in your trusted devices list</p>

      <!-- Trust Device Checkbox -->
      <div class="trust-device d-none">
        <div class="iconBox">
          <img src="../../../../assets/new-dash/login/saveDevice.svg" alt="Save Device" width="30">
        </div>
        <div class="contentWrapper">
          <h3 class="title">
            Trust this device for {{this.noOfDaysToTrustDevice}} days
          </h3>
          <p class="subTitle">
            You won't need to verify your identity when logging in from this device
          </p>
        </div>

      </div>

      <div class="trust-device">
        <mat-checkbox class="trustDeviceCheckbox" (change)="onCheckboxChange($event)">
          <div class="contentWrapper">
            <h3 class="title">
              Trust this device for {{this.noOfDaysToTrustDevice}} days
            </h3>
          </div>
        </mat-checkbox>
        <div class="subTitleWrapper">
          <mat-icon>info</mat-icon>
          <p class="subTitle">
            When you trust a device, you won't need to verify your identity when logging in from it for the next
            {{this.noOfDaysToTrustDevice}} days. You can manage your trusted devices anytime in Account Settings.
          </p>
        </div>

      </div>


      <form class="form-container-wrapper">
        <!-- Device Name Input -->
        <mat-form-field appearance="outline" class="myMatFormFieldCustom w-100" subscriptSizing="dynamic">
          <input matInput [placeholder]="deviceName" [(ngModel)]="deviceName" name="deviceName" type="text"
            (focus)="onDeviceNameFocus()"
            aria-label="Please enter a device name. This is an optional field.">
          <mat-hint>Give this device a name you'll recognize</mat-hint>
        </mat-form-field>
        <!-- <p class="hint">Give this device a name you'll recognize</p> -->

        <ion-button class="primary-general-btn w-100" matRipple (click)="saveDevice()"
          [disabled]="!isTrustDeviceChecked || !deviceName.trim()">
          <div *ngIf="isdeviceSave; else generalCondition">
            <app-loader></app-loader>
          </div>
          <ng-template #generalCondition>
            <span>Trust Device</span>
          </ng-template>
        </ion-button>
      </form>
      <div class="bottom-action-links mt-4">
        <a href="javascript:void(0);" (click)="skipDeviceSave()" class="link-items" mat-dialog-close>
          Not Now
        </a>
      </div>
    </div>
  </div>
</div>